import { apiGet } from '../../utilities/apiClient';
import { getSessionIds } from './_sessionIds';
import {
  ADD_CONTACTS,
  FETCHING_CONTACTS,
  FETCHED_CONTACTS,
  UPDATE_PROJECT,
} from '../constants';

export const fetchContacts = (projectId: number | string) => async (dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId || projectId == null) return;
  dispatch({ type: FETCHING_CONTACTS, payload: true });
  try {
    const res = await apiGet(`/contacts/get-all/${projectId}/${accountId}/${cognitoId}`);
    const data = res?.payload ?? res?.data ?? res;
    const list = Array.isArray(data) ? data : [];
    dispatch({ type: ADD_CONTACTS, payload: { project_id: String(projectId), list } });
    dispatch({ type: FETCHED_CONTACTS, payload: { project_id: String(projectId) } });
    dispatch({ type: UPDATE_PROJECT, payload: { id: projectId, contacts_count: list.length } });
  } catch {
    dispatch({ type: ADD_CONTACTS, payload: { project_id: String(projectId), list: [] } });
    dispatch({ type: FETCHED_CONTACTS, payload: { project_id: String(projectId) } });
  } finally {
    dispatch({ type: FETCHING_CONTACTS, payload: false });
  }
};
